import React, { useState, useEffect } from "react";
import {
  Box,
  Text,
  Heading,
  Flex,
  List,
  ListItem,
  Button,
  HStack,
  Input,
} from "@chakra-ui/react";
import { getFeedbackList } from "../utils/api"; // Import the reusable API function

const FeedbackList = () => {
  const [feedbackList, setFeedbackList] = useState([]);
  const [filteredFeedback, setFilteredFeedback] = useState([]); // For displaying filtered results
  const [searchQuery, setSearchQuery] = useState(""); // For search input
  const [currentPage, setCurrentPage] = useState(1); // Pagination
  const [error, setError] = useState("");
  const itemsPerPage = 3; // Items per page

  useEffect(() => {
    const fetchFeedback = async () => {
      try {
        const data = await getFeedbackList(); // Use the reusable API
        setFeedbackList(data);
        setFilteredFeedback(data); // Initialize filtered data
      } catch (err) {
        console.error("Error fetching feedback:", err);
        setError(err.message);
      }
    };

    fetchFeedback();
  }, []);

  // Pagination logic
  const totalPages = Math.ceil(filteredFeedback.length / itemsPerPage);
  const currentFeedbackList = filteredFeedback.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);

    // Filter feedback based on the search query
    const filtered = feedbackList.filter((feedback) => {
      const { name, email, phoneNumber, createdAt } = feedback;
      const dateString = new Date(createdAt).toLocaleString();
      return (
        name.toLowerCase().includes(query) ||
        email.toLowerCase().includes(query) ||
        phoneNumber.toLowerCase().includes(query) ||
        dateString.toLowerCase().includes(query)
      );
    });

    setFilteredFeedback(filtered);
    setCurrentPage(1); // Reset to first page on new search
  };

  if (error) {
    return (
      <Flex height="100vh" justifyContent="center" alignItems="center">
        <Text color="red.500">{error}</Text>
      </Flex>
    );
  }

  return (
    <>
      <Flex w="100%" justify="center">
        <Flex
          bg="white"
          p={6}
          rounded="lg"
          w="90%"
          maxW="800px"
          justify="center"
          align="center"
        >
          <Input
            placeholder="Search by Name, Email, Phone, or Date"
            className="input-fb"
            value={searchQuery}
            onChange={handleSearch}
            border="2px solid #1c4b7e"
            maxW="600px"
            w="100%"
            _focus={{
              borderColor: "#0078D7",
              boxShadow: "0px 4px 10px rgba(0, 120, 215, 0.6)",
            }}
          />
        </Flex>
      </Flex>

      <Flex justifyContent="center" alignItems="center" flexDirection="column">
        {/* Feedback List */}
        <List spacing={4}>
          {currentFeedbackList.map((feedback, index) => (
            <ListItem
              key={index}
              p={4}
              bg="white"
              boxShadow="0px 10px 20px rgba(0, 0, 0, 0.1), 0px 6px 6px rgba(0, 0, 0, 0.1)" // Floating effect
              rounded="lg"
            >
              <Flex justifyContent="space-between" alignItems="center">
                <Text color="#1c4b7e">
                  <strong>Name:</strong> {feedback.name}
                </Text>

                <Text color="#ef1414">
                  <strong>Contact:</strong> {feedback.contact}
                </Text>
              </Flex>
              <Text color="#1c4b7e">
                <strong>Email:</strong> {feedback.email}
              </Text>
              <Text color="#1c4b7e">
                <strong>Phone:</strong> {feedback.phoneNumber}
              </Text>
              <Text color="#1c4b7e">
                <strong>Comment:</strong> {feedback.comment}
              </Text>
              <Text color="#1c4b7e">
                <strong>Date Submitted:</strong>{" "}
                {new Date(feedback.createdAt).toLocaleString()}
              </Text>
            </ListItem>
          ))}
        </List>

        {/* Pagination Controls */}
        <HStack justifyContent="center" mt={6}>
          <Button
            onClick={handlePreviousPage}
            isDisabled={currentPage === 1}
            bg="#1c4b7e"
            color="white"
            _hover={{ bg: "#00aeef" }}
          >
            Previous
          </Button>
          <Text>
            Page {currentPage} of {totalPages}
          </Text>
          <Button
            onClick={handleNextPage}
            isDisabled={currentPage === totalPages}
            bg="#1c4b7e"
            color="white"
            _hover={{ bg: "#00aeef" }}
          >
            Next
          </Button>
        </HStack>
      </Flex>
    </>
  );
};

export default FeedbackList;
